import Bridge2 from "../../Assests/Bridge_2.jpg";
import Bridge6 from "../../Assests/Bridge_6.jpg";
import Bridge7 from "../../Assests/Bridge_7.jpg";

export const images = [
    Bridge2,
    Bridge6,
    Bridge7,
  ];